<div class="fc-content" [ngbPopover]="template" container="body" triggers="manual">
    <ng-content></ng-content>
</div>
